<div class="row no-gutters">
    <div class="col-12 text-right">
        <a id="{{idPrefix}}btn.add"
           mat-stroked-button
           color="accent"
           class="add-btn"
           (click)="create()">
            {{ 'workflow_management.btn.add_default_distribution_job' | translate }}
        </a>
    </div>
</div>

<distribution-job-list #distributionJobListComponent
                       *ngIf="workflow?.defaults?.distribution_jobs"
                       [idPrefix]="idPrefix"
                       [distributionJobList]="workflow.defaults.distribution_jobs"
                       [uriBuilderParamsFn]="generateWorkflowDistributionJobUriBuilderParamsForJob"
                       [externalReceiverList]="receiverList"
                       [externalUnfilteredAllAssignables]="unfilteredAllAssignables"
                       [externalDistributionChannels]="distributionChannels"
                       (tellMyParents)="detectChanges()">
</distribution-job-list>
